import Paper from "@material-ui/core/Paper";
import styled from "styled-components";

export const Root = styled(Paper)`
  ${({ theme }) => `
    padding: ${theme.spacing(2)}px;
  `}
`;
